import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';

import { ProductSettlementPeriodService } from 'src/app/angularJS/services/product-settlement-period/product-settlement-period.service';

import { ProductSettlementRequestService } from 'src/app/angularJS/services/product-settlement-request/product-settlement-requests.service';

import { UserService } from 'src/app/angularJS/services/user/user.service';

import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';

import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';

import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';

/**
 * A class that contains properties and method for triggering the end of a settlement period
 */
export class SettlementPeriodController {
  public static $inject = [
    'ACTToolbarService',
    'UserMessages',
    'productSettlementPeriodService',
    'productSettlementRequestService',
    'userService',
    'LinkBuilder',
    'QueryBuilder',
    'breadcrumbService'
  ];

  public paginatorData: InterACT.Interfaces.IPaginationData = {
    currentPage: 1,
    perPageCount: 5,
    totalCount: undefined
  };

  public closedPeriods: Array<any> = [];

  public activePeriod: InterACT.Interfaces.ProductSettlement.ProductSettlementPeriod = {
    scheme: {
      abbreviation: '',
      link: ''
    },
    startDate: '2018-05-31T11:33:00Z',
    scheduledEndDate: '2018-06-30T11:33:99Z',
    periodNumber: 38,
    status: 'OPEN'
  };

  constructor(
    private ActToolbarService: ACTToolbarService,
    private userMessages: UserMessagesService,
    private productSettlementPeriodService: ProductSettlementPeriodService,
    private productSettlementRequestService: ProductSettlementRequestService,
    private userService: UserService,
    private linkBuilder: LinkBuilder,
    private queryBuilder: QueryBuilder,
    private breadcrumbService: BreadcrumbService
  ) {
    this.activate();
  }

  /**
   * A method that gets the currently active product settlement period
   */
  public getActivePeriod() {
    const query = this.queryBuilder.newParam()
      .fieldIs('scheme.link', this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id))
      .and()
      .fieldIs('status', 'OPEN')
      .sortBy([{ columnName: 'periodNumber', direction: 'desc' }])
      .getParam();

    this.productSettlementPeriodService.getList(1, 1, query).then((response) => {
      this.activePeriod = response.productSettlementPeriods.length > 0 ? response.productSettlementPeriods[0].productSettlementPeriod : undefined;
    });
  }

  /**
   * A method that gets a page worth of completed settlement periods
   * @param page the page number to retrieve
   * @param perPage the number of completed periods to retrieve per page
   */
  public getClosedPeriods(page: number, perPage: number) {
    if (!perPage) {
      perPage = this.paginatorData.perPageCount;
    }

    if (!page) {
      page = this.paginatorData.currentPage;
    }

    const query = this.queryBuilder.newParam()
      .fieldIs('scheme.link', this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id))
      .and()
      .fieldIs('status', 'CLOSED')
      .sortBy([{ columnName: 'periodNumber', direction: 'desc' }])
      .getParam();

    return this.productSettlementPeriodService.getList(page, perPage, query).then((response) => {
      this.paginatorData.totalCount = response.meta.totalCount;
      this.closedPeriods = response.productSettlementPeriods.map((period) => period.productSettlementPeriod);
    });
  }

  /**
   * A method that sends a request to end the current product settlement period
   */
  public endSettlementPeriod() {
    this.userMessages.buildConfirmDialog(
      'END_SETTLEMENT_PERIOD',
      'CONFIRM_DIALOG.SETTLEMENT_PERIOD.SETTLEMENT_PERIOD_WILL_END_ON',
      { endDate: new Date().toUTCString().replace(' GMT', '') },
      'CONFIRM_DIALOG.SETTLEMENT_PERIOD.CONFIRM',
      'CONFIRM_DIALOG.SETTLEMENT_PERIOD.CANCEL'
    ).then(() => {
      const schemeLink = { link: this.linkBuilder.getSchemesLink(this.userService.selectedScheme.id) };
      const periodLink = {
        link: this.linkBuilder.getProductSettlementPeriodLink(this.activePeriod.id)
      };

      this.productSettlementRequestService.create(<any>schemeLink, periodLink).then(() => {
        this.userMessages.showToast('The current Settlement Period has now ended');
        this.getActivePeriod();
        this.getClosedPeriods(this.paginatorData.currentPage, this.paginatorData.perPageCount);
      });
    });
  }

  /**
   * A method that is called during controller instantiation to set up the controller
   */
  private activate() {
    this.getActivePeriod();
    this.getClosedPeriods(1, 5);
    this.breadcrumbService.setBreadcrumbs([{
      name: 'SETTLEMENT_PERIOD',
      sref: 'settlement-period'
    }]);
    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle('SETTLEMENT_PERIOD');
    });
  }
}